import React from "react";
import "./styles.scss";
import { GetIconByName } from "../../config/icon";

const ButtonIcon = ({ history, data, onClick }) => {
  return (
    <div
      className={`button-icon-wrp ${data.type} ${data.size}`}
      disabled={data.disable}
      onClick={!data.disable ? onClick : null}
    >
      <div className={"biw__icon"}>{GetIconByName(data.iconName)}</div>
    </div>
  );
};

export default ButtonIcon;
